export default "__VITE_PUBLIC_ASSET__79a68ffc__"